
<ng-container *ngIf="hasCarsInFleet">
    <app-common-alert-modal [actionBtnTitle]="modalData.actionBtnTitle" [title]="modalData.title" 
    [cancelBtnTitle]="modalData.cancelBtnTitle" [isModalOpen]="hasCarsInFleet" [actionType]="modalData.actionType"
    [message]="modalData.message" (isModalResponseClicked)="closePopupOnClick($event)" [hideSecondaryBtn]="'hide'"></app-common-alert-modal>
</ng-container>
<div *ngIf="showToast" class="toast-style">
    <app-toast [message]="message" [toastType]="toastType" [position]="position" [leftPosition]="leftPosition"></app-toast>
</div>
